import { BaseShareActionArgs, buildShareButtonComponent } from './base'
import { EmailIcon } from '../../assets/icons'
import { encodeShareURL } from '../../helpers/sharing_helper'

export const emailShareAction = ({
  shareUrl,
  subject = null,
  teaser = '',
  utmParams,
}: BaseShareActionArgs & { subject?: string | null }) => {
  const encodedSubject = encodeURIComponent(subject || teaser)
  const encodedBody = encodeShareURL(shareUrl, utmParams, `${teaser} `)
  return window.open(`mailto:?subject=${encodedSubject}&body=${encodedBody}`, '_self')
}

export const EmailButton = buildShareButtonComponent({
  action: emailShareAction,
  ariaLabel: 'Email',
  className: 'share-button--email',
  icon: EmailIcon,
})

export type EmailButtonProps = Parameters<typeof EmailButton>['0']
